/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/js-cookie/index.d.ts" />
/// <reference path="../../node_modules/devextreme/dist/ts/dx.all.d.ts" />

namespace Seac.Components {
	interface TreeStruttura {
		itemId		: number;
		subItemList	: Array<TreeStruttura>;
	}

	class LeftMenuService extends Seac.Commons.BaseService {
		constructor() {
			super();
		}

		/** Url per la configurazione del menù di navigazione */
		public menuNavigazione(visualizzaTutti: boolean): JQuery.jqXHR<Array<Seac.Models.MenuItem>> {
			const queryParams: Seac.Commons.QueryParams = <Seac.Commons.QueryParams>{
				visualizzaTutti: visualizzaTutti
			};
			return this.get(this.buildUrl([
				Seac.Commons.EndPoints.ACCOUNT.ROOT,
				Seac.Commons.EndPoints.ACCOUNT.ROUTE_MENU_NAVIGAZIONE
			], queryParams));
		}

		/** Lista degli ItemId preferiti */
		public preferitoList(): JQuery.jqXHR<Array<number>> {
			return this.get(
				Seac.Commons.EndPoints.ACCOUNT.ROOT,
				Seac.Commons.EndPoints.ACCOUNT.ROUTE_MENU_NAVIGAZIONE_PREFERITO_LIST
			);
		}

		/** Imposta l'item come preferito per l'utente */
		public impostaPreferito(menuItemId: number): JQuery.jqXHR {
			const data = {
				menuItemId: menuItemId
			};
			return this.post(
				data,
				Seac.Commons.EndPoints.ACCOUNT.ROOT,
				Seac.Commons.EndPoints.ACCOUNT.ROUTE_MENU_NAVIGAZIONE_IMPOSTA_PREFERITO
			);
		}

		/** Rimuove l'item come preferito per l'utente */
		public rimuoviPreferito(menuItemId: number): JQuery.jqXHR {
			const data = {
				menuItemId: menuItemId
			};
			return this.post(
				data,
				Seac.Commons.EndPoints.ACCOUNT.ROOT,
				Seac.Commons.EndPoints.ACCOUNT.ROUTE_MENU_NAVIGAZIONE_RIMUOVI_PREFERITO
			);
		}
	}

	export class LeftMenu {
		public static onMenuToggleEvent: string = 'onMenuToggle';

		// Attenzione al valore dell'animazione che è definito nel css `_variables.scss`
		private _leftMenuAnimationDuration	: number = 500;
		private _leftMenuContainer			: JQuery<HTMLElement>;
		private _appContainerInstance		: JQuery<HTMLElement>;
		private _treeListMenuInstance		: DevExpress.ui.dxTreeList;
		private _itemIdPreferitoList		: Array<boolean> = [];
		private _gestionePreferitiClass		: string;
		private _treeStruttura				: Array<Seac.Models.MenuItem>;
		private _leftMenuService			: LeftMenuService;

		constructor(leftMenuContainerId: string, appContainerId: string, treeListMenuId: string, menuItemClass: string, menuItemPreferitoClass: string, gestionePreferitiClass: string) {
			this._leftMenuContainer			= $(`#${leftMenuContainerId}`);
			this._appContainerInstance		= $(`#${appContainerId}`);
			this._treeListMenuInstance		= $(`#${treeListMenuId}`).dxTreeList(Seac.Commons.Constants.DevExpress.dxInstance);
			this._gestionePreferitiClass	= gestionePreferitiClass;
			this._leftMenuService			= new LeftMenuService();

			// Sottoscrivo l'evento onEditorPreparing per impostare il placeholder del filtro
			this._treeListMenuInstance.on(Seac.Commons.Constants.DevExpress.dxEditorPreparing, (event: any) => {
				if (event.parentType === Seac.Commons.Constants.DevExpress.dxFilterRow) {  
					event.editorOptions.placeholder = Seac.Resources.Common.cerca;  
				}  
			});

		//	//Imposto le azioni da eseguire quando il menu è pronto, utile alla gestione dell'arrivo in pagina tramite link. (Seleziona la voce di menu del link della pagina se presente nelle voci di menu)
		//	this._treeListMenuInstance.on(Seac.Commons.Constants.DevExpress.dxContentReady, (event: Seac.Commons.DxEvents.DxDataGridContentReadyEvent) => {
		//		const gridStoreArray	: Array<Seac.Models.MenuItem>	= this._treeListMenuInstance.getDataSource().store()._array;
		//		gridStoreArray.forEach((menuItem: Seac.Models.MenuItem) => {
		//			if (menuItem.Link == window.location.pathname) {
		//				//Nodo in questione
		//				const node					: DevExpress.ui.dxTreeListNode	= this._treeListMenuInstance.getNodeByKey(menuItem.Id);
		//				//Padre del nodo in questione
		//				const parentNode			: DevExpress.ui.dxTreeListNode	= node.parent;
		//				//Dati del nodo padre in questione
		//				const menuItemParentNode	: Seac.Models.MenuItem			= parentNode.data;
		//
		//				//Se il nodo Padre non ha altri livelli sopra
		//				if (!menuItemParentNode || !menuItemParentNode.PadreId) {
		//					//Espando la riga del padre
		//					this._treeListMenuInstance.expandRow(menuItemParentNode.Id);
		//					//Creo l'array che conterra le chiavi delle righe da selezionare(sempre a 1 la lenght)
		//					const keys: Array<number> = new Array<number>();
		//					keys.push(menuItem.Id);
		//					//Seleziono il nodo che ha come link l'url di destionazione della pagina
		//					this._treeListMenuInstance.selectRows(keys, false);
		//				}else {
		//					//Se il nodo Padre ha alti livelli sopra
		//					const parentParentNode			: DevExpress.ui.dxTreeListNode	= parentNode.parent; //Nodo padre del nodo padre in questione
		//					const menuItemParentParentNode	: Seac.Models.MenuItem			= parentParentNode.data;// Dati del nodo padre
		//					if (menuItemParentParentNode.PadreId == null) {//Se non ha altri livelli(Fino ad ora solo 3 livelli di espansione)
		//						this._treeListMenuInstance.expandRow(menuItemParentParentNode.Id);//Espando il nodo padre del padre
		//						const keys: Array<number> = new Array<number>();
		//						keys.push(menuItem.Id);
		//						this._treeListMenuInstance.selectRows(keys, false);//Seleziono la riga in questione
		//					}
		//				}
		//			}
		//		});
		//	});
			
			$(document).delegate(`.${menuItemClass}`, Commons.Constants.mouseDownEvent, (event: JQuery.MouseDownEvent) => {
				let tdContainer: JQuery<HTMLElement>;
				if (event.target.tagName === Seac.Commons.Constants.tdElement.toUpperCase()) {
					tdContainer = $(event.target);
				}else {
					tdContainer = $(event.target).parents(Seac.Commons.Constants.tdElement);
				}
				// Ricerco l'elemento contenente l'id del menu clikkato negli elementi figli
				let menuItemIdContainer: JQuery<HTMLElement> = tdContainer.find('[data-menu-item-id]');

				// Ricavo l'id dell'elemento
				const menuItemId: number = menuItemIdContainer.data('menu-item-id');

				// Ricavo l'indice DevExpress dell'elemento 
				const selectedRowIndex: number = this._treeListMenuInstance.getRowIndexByKey(menuItemId);
				// Seleziono l'elemento clikkato
				this._treeListMenuInstance.selectRowsByIndexes([selectedRowIndex]);

				// Qui ho l'elemento con i dati
				const selectedNode: DevExpress.ui.dxTreeListNode = this._treeListMenuInstance.getNodeByKey(menuItemId);
				if (!selectedNode) {
					// Se non ho selezionato nessun nodo esco senza far nulla
					return;
				}

				// Se l'elemento ha dei figli espando o comprimo la riga in base allo stato attuale
				if (selectedNode.hasChildren) {
					if (this._treeListMenuInstance.isRowExpanded(menuItemId)) {
						this._treeListMenuInstance.collapseRow(menuItemId);
					}else {
						this._treeListMenuInstance.expandRow(menuItemId);
					}
					// esco dal metodo, in quanto non devo fare nessun redirect
					return;
				}

				// Se non è stato clicckato l'elemento `anchor` eseguo la navigazione
				if ((<string>$(event.target).prop(Seac.Commons.Constants.nodeName)).toUpperCase() != Seac.Commons.Constants.anchorElement.toUpperCase()) {
					const menuItem: Seac.Models.MenuItem = selectedNode.data;
					switch(event.which)	{
						case 1:
							// Se è stato clickato il pulsante destro carico la pagina richiesta in questa finestra
							window.location.href = menuItem.Link;
						break;
						case 2:
							// Se è stato clickato il pulsante centrale carico la pagina richiesta in una nuova finestra
							window.open(menuItem.Link, Seac.Commons.Constants.targetBlank);
						break;
					}
				}
			});

			$(document).delegate(`.${menuItemPreferitoClass}`, Seac.Commons.Constants.mouseDownEvent, (event: JQuery.MouseDownEvent) => {
				event.stopPropagation();
				event.preventDefault();

				const parentItemNode	: HTMLElement	= $(event.currentTarget).parents('div[data-menu-item-id]')[0];
				const itemId			: number		= +$(parentItemNode).data('menu-item-id');
				// Cambio lo stato di preferito
				this.togglePreferito(itemId);
			});
		}

		/** Ritorna lo stato di apertura del menù laterale */
		public isOpened(): boolean {
			return !this._leftMenuContainer.hasClass('full-page');
		}

		/** Metodo richiamato dal pulsante che permette di visualizzare e nascondere il menu
			Il pulsante è nel componente TopMenuComponent */
		public toggleMenu(): void {
			if (this.isOpened()) {
				this.hideMenu();
			}else {
				this.showMenu();
			}
		}

		/** Visualizza il menu e rimuove il cookie 'isHiddenLeftMenu' in modo che venga visualizzato il menu ai successivi ricaricamenti della pagina */
		public showMenu(): void {
			this._leftMenuContainer.removeClass('d-none full-page');
			this._appContainerInstance.removeClass('full-page');
			$(Seac.Commons.Constants.body).addClass('left-menu-aperto').removeClass('left-menu-chiuso')
			Cookies.remove(Seac.Commons.ServerConstants.Constants.COOKIE_IS_LEFT_MENU_HIDDEN);
			// Alla fine dell'animazione emetto l'evento
			const animationInterval: NodeJS.Timeout = setInterval(() => {
				const event: CustomEvent = <CustomEvent>document.createEvent('CustomEvent');
				event.initCustomEvent(LeftMenu.onMenuToggleEvent, /* bubbles */true, /* cancelable */true, /* detail */ true);
				window.dispatchEvent(event);

				clearInterval(animationInterval);
				if (Seac.Pages.PageUtility.isMobileDevice) {
					// Se sono su un dispositovo mobile ,eseguo il refresh del menu perché sui dispositivi mobile potrebbe avere dei problemi se è stato ruotato lo schermo
					this._treeListMenuInstance.refresh()
						.then(() => {
							// Al termine del refresh scrollo il menu all'elemento selezionato
							const selectdRowKeys: Array<number> = this._treeListMenuInstance.getSelectedRowKeys();
							if (selectdRowKeys) {
								const rowIndex: number = this._treeListMenuInstance.getRowIndexByKey(selectdRowKeys[0]);
								const selectedElement: JQuery<HTMLElement> = this._treeListMenuInstance.getRowElement(rowIndex);
								this._treeListMenuInstance.getScrollable().scrollToElement(selectedElement);
							}
						});

				}

			}, this._leftMenuAnimationDuration)
		}

		/** Nasconde il menu e imposta il cookie 'isHiddenLeftMenu' in modo che non venga visualizzato il menu ai successivi ricaricamenti della pagina */
		public hideMenu(): void {
			this._leftMenuContainer.addClass('full-page');
			this._appContainerInstance.addClass('full-page');
			$(Seac.Commons.Constants.body).removeClass('left-menu-aperto').addClass('left-menu-chiuso');
			Cookies.set(Seac.Commons.ServerConstants.Constants.COOKIE_IS_LEFT_MENU_HIDDEN, 'true');
			// Alla fine dell'animazione emetto l'evento
			const animationInterval: NodeJS.Timeout = setInterval(() => {
				const event: CustomEvent = <CustomEvent>document.createEvent('CustomEvent');
				event.initCustomEvent(LeftMenu.onMenuToggleEvent, /* bubbles */true, /* cancelable */true, /* detail */ false);
				window.dispatchEvent(event);

				clearInterval(animationInterval);
			}, this._leftMenuAnimationDuration)
		}

		/** Effettua il caricamento degli Item del menù di navigazione */
		private caricaItemMenuNavigazione(isInGestionePreferiti: boolean): void {
			this._treeStruttura = null;
			// Carico la nuova struttura del menù di navigazione
			this._treeListMenuInstance.option(
				Seac.Commons.Constants.DevExpress.dxDataSource,
				new DevExpress.data.CustomStore({
					load: () => {
						// Imposto la chiamata differita
						const itemListDeferred: JQuery.Deferred<Array<Seac.Models.MenuItem>> = $.Deferred<Array<Seac.Models.MenuItem>>();

						this._leftMenuService.menuNavigazione(!isInGestionePreferiti)
							.then((itemList: Array<Seac.Models.MenuItem>) => {
								this._treeStruttura = itemList;

								return this._leftMenuService.preferitoList();
							})
							.then((itemIdList: Array<number>) => {
								this._itemIdPreferitoList = [];
								// Imposto gli id degli item preferiti
								for (let itemIdIndex = 0; itemIdIndex < itemIdList.length; itemIdIndex++) {
									this._itemIdPreferitoList[itemIdList[itemIdIndex]] = true;
								}

								itemListDeferred.resolve(this._treeStruttura);
							})
						;
						return itemListDeferred;
					},
					key : Seac.Commons.nameof(() => (<Seac.Models.MenuItem>null).Id)
				})
			);
		}

		/* -------------------------------------------------------------------------------- */
		/* Preferiti */

		/** Abilita / disabilita la gestione dei preferiti */
		public toggleGestionePreferiti(): void {
			const isInGestionePreferiti = this.isInGestionePreferiti();
			if (isInGestionePreferiti) {
				this._treeListMenuInstance.element().removeClass(this._gestionePreferitiClass);
			}else {
				this._treeListMenuInstance.element().addClass(this._gestionePreferitiClass);
			}

			this.caricaItemMenuNavigazione(isInGestionePreferiti);
		}

		/** Ritorna se la gestione dei preferiti è abilitata */
		public isInGestionePreferiti(): boolean {
			return this._treeListMenuInstance.element().hasClass(this._gestionePreferitiClass);
		}

		/** Imposta / rimuove lo stato di preferito da una voce di menù */
		public togglePreferito(itemId: number): void {
			if (this.isItemPreferito(itemId)) {
				this.rimuoviPreferito(itemId);
			}else {
				this.impostaPreferito(itemId);
			}
		}

		/** Imposta / rimuove lo stato di preferito da una voce di menù ed aggiorna anche i figli */
		private impostaRimuoviPreferito(itemId: number, isPreferito: boolean, aggiornaNodiFigli: boolean) {
			const rowIndex: number = this._treeListMenuInstance.getRowIndexByKey(itemId);
			// Per dare all'utente un effetto di immediatezza, cambio subito lo stato del flag.
			// In caso di errore lo ripristino.
			this._itemIdPreferitoList[itemId] = isPreferito;
			this._treeListMenuInstance.repaintRows([rowIndex]);
			this.aggiornaPadreItem(itemId);

			let chiamataServer: JQuery.jqXHR;
			// Imposto o rimuovo lo stato lato server
			if (isPreferito) {
				chiamataServer = this._leftMenuService.impostaPreferito(itemId);
			}else {
				chiamataServer = this._leftMenuService.rimuoviPreferito(itemId);
			}

			// Attendo l'esito dell'impostazione
			chiamataServer
				.then(() => {
					// Se vanno aggiornati anche i figli richiamo la funzione su tutti i nodi sottostanti
					if (aggiornaNodiFigli) {
						// Apro il nodo per visualizzare i figli
						this._treeListMenuInstance.expandRow(itemId);

						const subItemList: Array<Seac.Models.MenuItem> = this._treeStruttura.filter((item: Seac.Models.MenuItem) => item.PadreId == itemId);
						// Effettuo l'impostazione su tutti i nodi figli assieme
						for (let subItemIndex = 0; subItemIndex < subItemList.length; subItemIndex++) {
							this.impostaRimuoviPreferito(
								subItemList[subItemIndex].Id,
								isPreferito,
								aggiornaNodiFigli
							);
						}
					}
				})
				.catch(() => {
					// Ripristino il valore precedente
					this._itemIdPreferitoList[itemId] = !isPreferito;
					this._treeListMenuInstance.repaintRows([rowIndex]);
					this.aggiornaPadreItem(itemId);
				})
			;
		}

		/** Imposta lo stato di preferito da una voce di menù */
		public impostaPreferito(itemId: number): void {
			this.impostaRimuoviPreferito(
				/* itemId */			itemId,
				/* isPreferito */		true,
				/* aggiornaNodiFigli */	true
			);
		}

		/** Rimuove lo stato di preferito da una voce di menù */
		public rimuoviPreferito(itemId: number): void {
			this.impostaRimuoviPreferito(
				/* itemId */			itemId,
				/* isPreferito */		false,
				/* aggiornaNodiFigli */	true
			);
		}

		/** Aggiorna l'item padre del nodo */
		private aggiornaPadreItem(itemId: number): void {
			// Cerco l'item con id itemId
			const itemList: Array<Seac.Models.MenuItem> = this._treeStruttura.filter((item: Seac.Models.MenuItem) => item.Id == itemId);
			if (itemList.length != 1) {
				return ;
			}

			// Cerco l'item padre
			const itemPadreList: Array<Seac.Models.MenuItem> = this._treeStruttura.filter((item: Seac.Models.MenuItem) => item.Id == itemList[0].PadreId);
			if (itemPadreList.length != 1) {
				return ;
			}

			// Aggiorno il nodo padre
			this.impostaRimuoviPreferito(
				/* itemId */			itemPadreList[0].Id,
				/* isPreferito */		this.isAllSubItemsPreferito(itemPadreList[0].Id),
				/* aggiornaNodiFigli */	false
			);
			// Aggiorno il nodo padre del padre
			if (itemPadreList[0].PadreId) {
				this.aggiornaPadreItem(itemPadreList[0].PadreId);
			}
		}

		/** Ritorna se un determinato item è preferito */
		public isItemPreferito(itemId: number): boolean {
			return !!this._itemIdPreferitoList[itemId];
		}

		/** Ritorna se tutti gli item sottostanti sono preferiti */
		private isAllSubItemsPreferito(itemId: number): boolean {
			if (!this._treeStruttura) {
				return false;
			}
			// Cerco tutti gli item figlio
			const subItemList: Array<Seac.Models.MenuItem> = this._treeStruttura.filter((item: Seac.Models.MenuItem) => item.PadreId == itemId);
			// Controllo lo stato dei sotto item, se sono preferiti oppure uno dei loro sotto item è preferito, allora anche l'item richiesto ha sotto item preferiti
			for (let subItemIndex = 0; subItemIndex < subItemList.length; subItemIndex++) {
				if (!this.isItemPreferito(subItemList[subItemIndex].Id)) {
					return false;
				}
			}
		
			// Tutti i sotto item sono preferiti
			return true;
		}

		/** Ritorna se almeno uno degli item sottostanti è preferito */
		public isSubItemsPreferito(itemId: number): boolean {
			if (!this._treeStruttura) {
				return false;
			}
			// Cerco tutti gli item figlio
			const subItemList: Array<Seac.Models.MenuItem> = this._treeStruttura.filter((item: Seac.Models.MenuItem) => item.PadreId == itemId);
			// Controllo lo stato dei sotto item, se sono preferiti oppure uno dei loro sotto item è preferito, allora anche l'item richiesto ha sotto item preferiti
			for (let subItemIndex = 0; subItemIndex < subItemList.length; subItemIndex++) {
				if (this.isItemPreferito(subItemList[subItemIndex].Id)) {
					return true;
				}
				if (this.isSubItemsPreferito(subItemList[subItemIndex].Id)) {
					return true;
				}
			}
		
			// Nessun sotto item è preferito
			return false;
		}
	}

	// Viene inizializzato nella View
	export let leftMenuComponent: LeftMenu;
}
